import { type Repub, REPUBS } from '@cx-modules/constants';

export const hreflangsRepub: Record<string, { repub: Repub }> = {
  'en-gb': {
    repub: REPUBS.OC.name,
  },
  'en-us': {
    repub: REPUBS.US.name,
  },
  'en-ca': {
    repub: REPUBS.CA.name,
  },
  'it-it': {
    repub: REPUBS.IT.name,
  },
  'es-es': {
    repub: REPUBS.ES.name,
  },
  'pt-br': {
    repub: REPUBS.BR.name,
  },
  'es-co': {
    repub: REPUBS.CO.name,
  },
  'en-au': {
    repub: REPUBS.AU.name,
  },
  'en-nz': {
    repub: REPUBS.NZ.name,
  },
  'en-in': {
    repub: REPUBS.IN.name,
  },
  'pt-pt': {
    repub: REPUBS.PT.name,
  },
  'en-za': {
    repub: REPUBS.ZA.name,
  },
  'en-ke': {
    repub: REPUBS.KE.name,
  },
  'en-ng': {
    repub: REPUBS.NG.name,
  },
  'nl-nl': {
    repub: REPUBS.NL.name,
  },
  'fr-fr': {
    repub: REPUBS.FR.name,
  },
  'sv-se': {
    repub: REPUBS.SE.name,
  },
  'it-sm': {
    repub: REPUBS.SM.name,
  },
  'en-cx': {
    repub: REPUBS.CX.name,
  },
  'en-ws': {
    repub: REPUBS.WS.name,
  },
};

export const ONE_DAY = 86400000;
